import React, { useState, useEffect } from 'react';
import styles from './Wishlist.module.css';
import { useContext } from 'react';
import { LanguageContext } from '../LanguageContext/LanguageContext';
import { Link, useNavigate } from 'react-router-dom';
import RemoveIcon from '../../assets/RemoveIcon';
import axios from 'axios';
import ProfileNavigation from '../ProfileNavigation/ProfileNavigation';
import { useLocation } from "react-router-dom";
import { PopupProvider } from "../Login/PopupContext.jsx";
// Sample datas
const wishlistItems = [
  {
    id: 1,
    title: 'Fundamentals of film directing',
    image: '/images/film-directing.jpg',
    category: 'Film Making',
  },
  {
    id: 2,
    title: 'Fundamentals of sound recording',
    image: '/images/sound-recording.jpg',
    category: 'Audio Production',
  },
  {
    id: 3,
    title: 'Fundamentals of acting',
    image: '/images/acting.jpg',
    category: 'Performance Arts',
  },
];

// Sample articles data
const articles = [
  {
    id: 1,
    title: 'مفلمنا توفير محتوى تعليمي عالي الجودة',
    image: '/images/article1.jpg',
    link: '/home/insights/1'
  },
  {
    id: 2,
    title: 'مفلمنا توفير محتوى تعليمي عالي الجودة',
    image: '/images/article2.jpg',
    link: '/home/insights/2'
  },
  {
    id: 3,
    title: 'مفلمنا توفير محتوى تعليمي عالي الجودة',
    image: '/images/article3.jpg',
    link: '/home/insights/3'
  }
];

const marketingBackendUrl = import.meta.env.VITE_MARKETING_BACKEND_URL;

const Wishlist = () => {
  const { direction } = useContext(LanguageContext);
  const isRTL = direction === 'rtl';
  const navigate = useNavigate();
  const [courseWishlist, setCourseWishlist] = useState([]);
  const [blogWishlist, setBlogWishlist] = useState([]);
  const [loading, setLoading] = useState(true);
  const [courseError, setCourseError] = useState(false);
  const [blogError, setBlogError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const [notification, setNotification] = useState({ show: false, message: '' });

  // Add loader effect
  useEffect(() => {
    setIsLoading(true);
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, [location.pathname]);
  // Add check for logged-in user
  const userEmail = localStorage.getItem("useremailidis");
  
  if (!userEmail) {
    return (
      <div className={styles.loggedOutContainer}>
        <div className={styles.loggedOutMessage}>
          <h2>
            {isRTL 
              ? "أنت غير مسجل الدخول"
              : "You are logged out"
            }
          </h2>
          <p>
            {isRTL
              ? "يرجى تسجيل الدخول للوصول إلى قائمة الرغبات الخاصة بك"
              : "Please login to access your wishlist"
            }
          </p>
          <Link to="/home/login" className={styles.loginButton}>
            {isRTL ? "تسجيل الدخول" : "Login"}
          </Link>
        </div>
      </div>
    );
  }

  useEffect(() => {
    const fetchWishlists = async () => {
      try {
        const userEmail = localStorage.getItem("useremailidis");
        if (!userEmail) {
          navigate("/home/login");
          return;
        }

        // Fetch course wishlist
        const courseResponse = await axios.get(`${marketingBackendUrl}/maflam/wishlist/${userEmail}`);
        if (courseResponse.data.success) {
          setCourseWishlist(courseResponse.data.data);
        } else {
          console.info(direction === "rtl"
            ? 'لا توجد دورات في قائمة الرغبات'
            : 'No courses in wishlist');
        }

        // Fetch blog wishlist
        const blogResponse = await axios.get(`${marketingBackendUrl}/maflam/blog-wishlist/${userEmail}`);
        if (blogResponse.data.success) {
          setBlogWishlist(blogResponse.data.data);
        } else {
          console.info(direction === "rtl"
            ? 'لا توجد مقالات في قائمة الرغبات'
            : 'No articles in wishlist');
        }

        // Check if both lists are empty
        if (!courseResponse.data.data?.length && !blogResponse.data.data?.length) {
          console.info(direction === "rtl"
            ? 'قائمة الرغبات فارغة'
            : 'Your wishlist is empty');
        }

      } catch (error) {
        console.error('Error fetching wishlist:', error);

      } finally {
        setLoading(false);
      }
    };

    fetchWishlists();
  }, [direction, navigate]);

  const handleRemoveCourse = async (courseNameEnglish) => {
    try {
      const userEmail = localStorage.getItem("useremailidis");
      
      const response = await axios.post(`${marketingBackendUrl}/maflam/wishlist/remove-course`, {
        userEmail,
        courseNameEnglish
      });

      if (response.data.success) {
        setCourseWishlist(prev => prev.filter(item => item.courseNameEnglish !== courseNameEnglish));
        setNotification({
          show: true,
          message: direction === "rtl"
            ? 'تم حذف الدورة من قائمة الرغبات'
            : 'Course removed from wishlist'
        });

        // Auto hide after 2 seconds
        setTimeout(() => {
          setNotification({ show: false, message: '' });
        }, 2000);
      }
    } catch (error) {
      console.error('Error removing course:', error);
      setNotification({
        show: true,
        message: direction === "rtl"
          ? 'حدث خطأ أثناء حذف الدورة'
          : 'Error removing course'
      });
    }
  };

  const handleRemoveBlog = async (headingEnglish) => {
    try {
      const userEmail = localStorage.getItem("useremailidis");
      
      const response = await axios.post(`${marketingBackendUrl}/maflam/blog-wishlist/remove-blog`, {
        userEmail,
        headingEnglish
      });

      if (response.data.success) {
        setBlogWishlist(prev => prev.filter(item => item.headingEnglish !== headingEnglish));
        setNotification({
          show: true,
          message: direction === "rtl"
            ? 'تم حذف المقال من قائمة الرغبات'
            : 'Article removed from wishlist'
        });

        // Auto hide after 2 seconds
        setTimeout(() => {
          setNotification({ show: false, message: '' });
        }, 2000);
      }
    } catch (error) {
      console.error('Error removing blog:', error);
      setNotification({
        show: true,
        message: direction === "rtl"
          ? 'حدث خطأ أثناء حذف المقال'
          : 'Error removing article'
      });
    }
  };

  if (loading) {
    return <div className={styles.loading}>
     
    </div>;
  }

  return (
    <div className={styles.container}>
      {notification.show && (
        <div className={styles.notification}>
          {notification.message}
        </div>
      )}
      {isLoading && (
        <div className={styles.loaderWrapper}>
          <span className={styles.loader}></span>
        </div>
      )}
      <ProfileNavigation />

      {/* Courses Section */}
      <h2 className={styles.sectionTitle}>
        {isRTL ? 'الدورات المتخصصة' : 'Courses'}
      </h2>
      <div className={styles.wishlistGrid}>
        {courseError ? (
          <div className={styles.emptyState}>
            {isRTL 
              ? 'لا توجد دورات في قائمة الرغبات' 
              : 'No courses in wishlist'
            }
          </div>
        ) : courseWishlist.length === 0 ? (
          <div className={styles.emptyState}>
            {isRTL 
              ? 'لا توجد دورات في قائمة الرغبات' 
              : 'No courses in wishlist'
            }
          </div>
        ) : (
          courseWishlist.map((item) => (
            <div key={item.courseNameEnglish} className={styles.wishlistCard}>
              <button 
                className={styles.removeButton}
                onClick={() => handleRemoveCourse(item.courseNameEnglish)}
                aria-label="Remove from wishlist"
              >
                <RemoveIcon className={styles.removeIcon} />
              </button>
              <Link to={item.redirectionLink} className={styles.cardLink}>
                <div className={styles.imageContainer}>
                  <img 
                    src={item.courseThumbnail} 
                    alt={direction === "rtl" ? item.courseNameArabic : item.courseNameEnglish} 
                    className={styles.courseImage} 
                  />
                  <div className={styles.overlay}>
                    <h3 className={styles.courseTitle}>
                      {direction === "rtl" ? item.courseNameArabic : item.courseNameEnglish}
                    </h3>
                  </div>
                </div>
              </Link>
            </div>
          ))
        )}
      </div>

      {/* Articles Section */}
      <h2 className={styles.sectionTitle}>
        {isRTL ? 'المقالات' : 'Articles'}
      </h2>
      <div className={styles.wishlistGrid}>
        {blogError ? (
          <div className={styles.emptyState}>
            {isRTL 
              ? 'لا توجد مقالات في قائمة الرغبات' 
              : 'No articles in wishlist'
            }
          </div>
        ) : blogWishlist.length === 0 ? (
          <div className={styles.emptyState}>
            {isRTL 
              ? 'لا توجد مقالات في قائمة الرغبات' 
              : 'No articles in wishlist'
            }
          </div>
        ) : (
          blogWishlist.map((item) => (
            <div key={item.headingEnglish} className={styles.wishlistCard}>
              <button 
                className={styles.removeButton}
                onClick={() => handleRemoveBlog(item.headingEnglish)}
                aria-label="Remove from wishlist"
              >
                <RemoveIcon className={styles.removeIcon} />
              </button>
              <Link to={item.redirectionLink} className={styles.cardLink}>
                <div className={styles.imageContainer}>
                  <img 
                    src={item.thumbnail} 
                    alt={direction === "rtl" ? item.headingArabic : item.headingEnglish} 
                    className={styles.courseImage} 
                  />
                  <div className={styles.overlay}>
                    <h3 className={styles.courseTitle}>
                      {direction === "rtl" ? item.headingArabic : item.headingEnglish}
                    </h3>
             
                  </div>
                </div>
              </Link>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Wishlist; 